module.exports = __webpack_public_path__ + "static/media/image3.c33aacc0.svg";